import { DialogManager } from "@lib/titan2/dist/game/manager/DialogManager";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
/**
 * GameDialogManager.ts
 */
export class GameDialogManager extends DialogManager {
    /**
     * The preload and open methods are sometimes called without being given portrait properties.
     * Many of these calls come from anonymous event handler closures in the dialog controller.
     * As such, until this is fixed, we need to rediscover the portrait properties through the key of the landscape properties.
     */
    rediscoverPortraitProperties(properties) {
        const key = Object.keys(this.landscapeProperties).find((k) => this.landscapeProperties[k] === properties);
        Logger.verbose(`Portrait properties rediscovered for dialog "${key}"`);
        return this.portraitProperties[key];
    }
    preload(properties, portraitProperties, data) {
        portraitProperties ?? (portraitProperties = this.rediscoverPortraitProperties(properties));
        super.preload(properties, portraitProperties, data);
    }
    open(properties, portraitProperties, data, refresh) {
        portraitProperties ?? (portraitProperties = this.rediscoverPortraitProperties(properties));
        super.open(properties, portraitProperties, data, refresh);
    }
}
//# sourceMappingURL=GameDialogManager.js.map